import React from "react";
import TAngel from "../Assets/img/Home/t_angel.png";
import Microsoft from "../Assets/img/Home/microsoft.png";
import Lab32 from "../Assets/img/Home/lab_32.png";
import SmartUp from "../Assets/img/Home/smart_up.png";
import styles from "../Assets/css/awards.module.css";
const Awards = () => {
	return (
		<div style={{ marginTop: "10%", marginBottom: "10%" }}>
			<h1
				className={styles.awardscollabheading}
				style={{ textAlign: "center" }}
			>
				Awards and Recognition
			</h1>
			<div
				className="container-fluid"
				style={{
					marginTop: "5%",
					paddingLeft: "50px",
					paddingRight: "50px",
				}}
			>
				<div class="row justify-content-around">
					<div class="col-xl-6 col-lg-6 col-md-6 d-flex justify-content-around">
						<div
							className={`${styles.awardsdiv4} ${styles.awardscollabdiv}`}
						>
							<div
								className={`${styles.awardscimg} ${styles.awc4}`}
							>
								<img
									src={Microsoft}
									alt=""
									className={`${styles.imgfluid} ${styles.img3}`}
								/>
							</div>
							<br />
							<div className={styles.awardsc}>
								<h5>Global Training Partner</h5>
								Exclusive access to <br />
								MS Certifications, GitHub, Outlook
							</div>
						</div>

						<div
							className={`${styles.awardsdiv3} ${styles.awardscollabdiv}`}
						>
							<div
								className={`${styles.awardscimg} ${styles.awc3}`}
							>
								<img
									src={SmartUp}
									alt=""
									className={`${styles.imgfluid} ${styles.img3}`}
								/>
							</div>
							<br />
							<div className={styles.awardsc}>
								<h5>Winner of All India</h5>
								Received a sum of Rs0.33crore
								<br />
								in form of a grant.
							</div>
						</div>
					</div>
					<div class="col-xl-6 col-lg-6 col-md-6 d-flex justify-content-around">
						<div className={styles.awardscollabdiv}>
							<div className={styles.awardscimg}>
								<img
									src={TAngel}
									alt=""
									className={`${styles.imgfluid} ${styles.img2} mb-3`}
									style={{ width: "80%", height: "75%" }}
								/>
							</div>
							<div className={styles.awardsc}>
								<h5>Part of T-Angel</h5>
								Investment readiness program
							</div>
						</div>
						<div className={styles.awardscollabdiv}>
							<div className={styles.awardscimg}>
								<img
									src={Lab32}
									alt=""
									className={`${styles.imgfluid} ${styles.img1}`}
								/>
							</div>
							<br />
							<div className={styles.awardsc}>
								<h5>Part of Lab-32</h5>
								Start-up Incubation
								<br />
								program
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Awards;
